{
  "version": 1,
  "asset_id": "d1d2e5c9-b7bc-4d28-a108-efbc212514c4",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/d1d2e5c9-b7bc-4d28-a108-efbc212514c4/hiatal-type-4-es-v3-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/d1d2e5c9-b7bc-4d28-a108-efbc212514c4/hiatal-type-4-es-v3-800.webp",
  "original_filename": "hiatal-type-4-es-v3-800.webp",
  "size": 103556,
  "content_type": "image/webp",
  "created_at": "2026-10-28T23:03:56Z"
}
